import React from "react";
import { UTDSelector, UTDJump } from "./";

export function HistoryNavbar({ chronicle, parent }) {
  console.log("UTD HISTORY BAR RENDER");
  const isDisabled = chronicle && chronicle.setupComplete ? false : true;
  // console.log('CHRONICLE HISTORY NAVBAR Disabled', isDisabled);
  const { unitDisplayCount } = chronicle;
  return (
    <div className="chronos-history-navigation-bar">
      <div className="chronos-history-minimap-wrapper">
        {/* Wrapper for the minimap/slider */}
      </div>
      <div className="chronos-history-quick-nav">
        <UTDJump
          disabled={isDisabled}
          parentRef={parent}
          displayedUnits={unitDisplayCount}
        />
        <UTDSelector
          disabled={isDisabled}
          unitDisplayCount={unitDisplayCount}
        />
      </div>
    </div>
  );
}
